import { seasonHex } from "./podcast-cover";

export function EpisodeBadge({
  seasonNumber,
  episodeNumber,
  size = "md",
}: {
  seasonNumber: number | null;
  episodeNumber: number | null;
  size?: "md" | "sm";
}) {
  const sizeClass =
    size === "sm" ? "size-12 rounded-[10px]" : "size-14 rounded-[14px] sm:size-16";
  const numberSize = size === "sm" ? "text-[17px]" : "text-h6";
  return (
    <div
      style={{ background: seasonHex(seasonNumber) }}
      className={`${sizeClass} flex shrink-0 flex-col items-center justify-center text-white`}
    >
      <span className="text-[9px] font-bold tracking-[0.12em] uppercase text-white/75">
        EP
      </span>
      <span className={`${numberSize} font-extrabold leading-none`}>
        {episodeNumber ?? "—"}
      </span>
    </div>
  );
}
